import {useViewController} from "data/services/locator";
import {ILocalizationController} from "views/controllers/localization/localization.controller";
import {Bindings} from "data/constants/bindings";

export const useI18n = () => {
	const {i18n} = useViewController<ILocalizationController>(Bindings.LocalizationController);
	return i18n;
};
